<template>
    <div class="main">
        <navigator></navigator>
        <div class="main-body"> 
            <router-view/>
        </div>
        <footer-page></footer-page>
    </div>
    
</template>

<script> 
    import Navigator from './components/navigator';
    import FooterPage from './components/footer';

    export default {
        name: 'Container',
        components: {
            Navigator,
            FooterPage
        },
        mixins: [],
        computed: { 
        }
    }
</script>